import GalleryContainer from './GalleryContainer';

export default GalleryContainer;
